import React from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import CorporateApi from "Services/CorporateEmployee";

import countryCodeData from "./data/countryCode/index.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const readStoredJSON = (value) => {
  if (!value) return {};
  try {
    return JSON.parse(value);
  } catch (error) {
    return {};
  }
};

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

const resolveBusinessId = ({ propId, profileDetails, authUser }) => {
  const storedProfileDetails =
    typeof window !== "undefined" ? readStoredJSON(window.localStorage.getItem("profiledetails")) : {};
  const storedAuthUser =
    typeof window !== "undefined" ? readStoredJSON(window.localStorage.getItem("authUser")) : {};

  return firstDefined(
    profileDetails?._id,
    profileDetails?.businessId,
    profileDetails?.business_id,
    profileDetails?.corporateId,
    profileDetails?.corporate_id,
    profileDetails?.companyId,
    profileDetails?.company_id,
    profileDetails?.tenantId,
    profileDetails?.tenant_id,
    authUser?._id,
    authUser?.businessId,
    authUser?.business_id,
    authUser?.corporateId,
    authUser?.corporate_id,
    authUser?.companyId,
    authUser?.company_id,
    authUser?.tenantId,
    authUser?.tenant_id,
    storedProfileDetails?._id,
    storedProfileDetails?.businessId,
    storedProfileDetails?.business_id,
    storedProfileDetails?.corporateId,
    storedProfileDetails?.corporate_id,
    storedProfileDetails?.companyId,
    storedProfileDetails?.company_id,
    storedProfileDetails?.tenantId,
    storedProfileDetails?.tenant_id,
    storedAuthUser?._id,
    storedAuthUser?.businessId,
    storedAuthUser?.business_id,
    storedAuthUser?.corporateId,
    storedAuthUser?.corporate_id,
    storedAuthUser?.companyId,
    storedAuthUser?.company_id,
    storedAuthUser?.tenantId,
    storedAuthUser?.tenant_id,
    propId
  );
};

const EmployeeCreate = (props) => {
  const { openDialog, handleClose, id } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileDetailsRaw = useSelector(
    (state) => state?.ProfileSettingsReducer?.profiledetails
  );
  const authUser = useSelector((state) => state?.AuthReducer?.user || {});
  const profileDetails =
    typeof profileDetailsRaw === "string" ? readStoredJSON(profileDetailsRaw) : profileDetailsRaw || {};
  const businessId = authUser.id;

  const countryCodes = Array.isArray(countryCodeData) ? countryCodeData : [];

  const handleAddEmployee = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    if (!businessId) {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Business id is missing from redux/localStorage. Please reconnect and try again.",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      return;
    }

    const data = {
      name: formValues?.name,
      firstName: formValues?.first_name,
      first_name: formValues?.first_name,
      lastName: formValues?.last_name,
      last_name: formValues?.last_name,
      email: formValues?.email,
      mobileNumber: formValues?.mobile_number,
      phone: formValues?.phone,
      mobile_number: formValues?.mobile_number,
      password: formValues?.password,
      gender: formValues?.gender,
      country_code: formValues?.country_code,
      city: formValues?.city,
      state: formValues?.state,
      postal_code: formValues?.postal_code,
      country: formValues?.country,
      address: formValues?.address,
      image: formValues?.image || "",
      user_type: "fleet manager",
      referral_by: businessId,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.success === true || res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Employee Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while create Employee",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    CorporateApi.addFleetManager(businessId, data).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      mobile_number: "",
      password: "",
      gender: "",
      country_code: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      address: "",
      image: "",
    },
    validationSchema: yup.object({
      name: yup.string().required("Name is required").nullable(),
      first_name: yup.string().required("First name is required").nullable(),
      last_name: yup.string().required("Last name is required").nullable(),
      email: yup.string().email("Invalid email").required("Email is required").nullable(),
      phone: yup.string().required("Phone is required").nullable(),
      mobile_number: yup.string().required("Mobile number is required").nullable(),
      password: yup.string().required("Password is required").nullable(),
      gender: yup.string().required("Gender is required").nullable(),
      country_code: yup.string().required("Country code is required").nullable(),
      city: yup.string().required("City is required").nullable(),
      state: yup.string().required("State is required").nullable(),
      postal_code: yup.string().required("Postal code is required").nullable(),
      country: yup.string().required("Country is required").nullable(),
      address: yup.string().required("Address is required").nullable(),
    }),
    onSubmit: handleAddEmployee,
    enableReinitialize: true,
  });

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      aria-describedby="dialog-box"
      className={classes.root}
    >
      <DialogTitle>
        <section className={classes.dialogTitleContainer}>
          <Typography variant="body1" className={classes.title}>
            Add Employee
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </section>
      </DialogTitle>

      <DialogContent>
        <Grid container>
          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="first_name"
                          id="first_name"
                          label="First Name"
                          value={formik.values.first_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                          helperText={formik.touched.first_name && formik.errors.first_name}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="last_name"
                          id="last_name"
                          label="Last Name"
                          value={formik.values.last_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                          helperText={formik.touched.last_name && formik.errors.last_name}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="email"
                          id="email"
                          label="Email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.email && Boolean(formik.errors.email)}
                          helperText={formik.touched.email && formik.errors.email}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid container>
                        <Grid item xs={4} className={classes.textFieldWrapper}>
                          <TextField
                            name="country_code"
                            id="country_code"
                            label="Country Code"
                            value={formik.values.country_code}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            select
                            error={formik.touched.country_code && Boolean(formik.errors.country_code)}
                            helperText={formik.touched.country_code && formik.errors.country_code}
                            fullWidth
                            variant="outlined"
                            size="small"
                          >
                            <MenuItem value="" disabled>
                              Select
                            </MenuItem>
                            {countryCodes.map((country) => (
                              <MenuItem key={country.code} value={country.dial_code}>
                                {`${country.code} (${country.dial_code})`}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={8} className={classes.textFieldWrapper}>
                          <TextField
                            name="phone"
                            id="phone"
                            label="Phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                            fullWidth
                            variant="outlined"
                            size="small"
                            autoComplete="off"
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="password"
                          id="password"
                          label="Password"
                          type="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.password && Boolean(formik.errors.password)}
                          helperText={formik.touched.password && formik.errors.password}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="new-password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="mobile_number"
                          id="mobile_number"
                          label="Mobile Number"
                          value={formik.values.mobile_number}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.mobile_number && Boolean(formik.errors.mobile_number)}
                          helperText={formik.touched.mobile_number && formik.errors.mobile_number}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="gender"
                          id="gender"
                          label="Gender"
                          value={formik.values.gender}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          select
                          error={formik.touched.gender && Boolean(formik.errors.gender)}
                          helperText={formik.touched.gender && formik.errors.gender}
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                          <MenuItem value="" disabled>
                            Select
                          </MenuItem>
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </TextField>
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="country"
                          id="country"
                          label="Country"
                          value={formik.values.country}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.country && Boolean(formik.errors.country)}
                          helperText={formik.touched.country && formik.errors.country}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="city"
                          id="city"
                          label="City"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.city && Boolean(formik.errors.city)}
                          helperText={formik.touched.city && formik.errors.city}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="state"
                          id="state"
                          label="State"
                          value={formik.values.state}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.state && Boolean(formik.errors.state)}
                          helperText={formik.touched.state && formik.errors.state}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="postal_code"
                          id="postal_code"
                          label="Postal Code"
                          value={formik.values.postal_code}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.postal_code && Boolean(formik.errors.postal_code)}
                          helperText={formik.touched.postal_code && formik.errors.postal_code}
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="address"
                          id="address"
                          label="Address"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.address && Boolean(formik.errors.address)}
                          helperText={formik.touched.address && formik.errors.address}
                          fullWidth
                          variant="outlined"
                          size="small"
                          multiline
                          minRows={3}
                          autoComplete="off"
                        />
                      </Grid>

                      <Grid item xs={12} className={classes.textFieldWrapper}>
                        <TextField
                          name="image"
                          id="image"
                          label="Image URL"
                          value={formik.values.image}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          helperText="Optional"
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} className={classes.sbtBtnWrapper}>
            <Button variant="contained" onClick={formik.handleSubmit}>
              Add Employee
            </Button>
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />
      <DialogActions>
        <section className={classes.dialogActions}>
          <section className={classes.closeBtn}>
            <Button onClick={handleClose}>Close</Button>
          </section>
        </section>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeCreate;
